import { render, staticRenderFns } from "./WeeklyWorkLabCreate.vue?vue&type=template&id=3369dd34"
import script from "./WeeklyWorkLabCreate.vue?vue&type=script&lang=js"
export * from "./WeeklyWorkLabCreate.vue?vue&type=script&lang=js"
import style0 from "./WeeklyWorkLabCreate.vue?vue&type=style&index=0&id=3369dd34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports